import {
  ITennisResults
} from "@sky-it-livedata/livedata-sports-design-system";
import { isNotEmptyArray, loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";
import { ResultsSubscriptionData } from "./types";
import { composeEmptyPlayers } from "./results-utils";

const logger = loggerFactory();

const isValidObject = (obj: ResultsSubscriptionData) =>
  Boolean(obj?.data?.onUpdateResultsWidgetByDay);

export const transformSubscription = (obj: ResultsSubscriptionData): ITennisResults => {
  if (isValidObject(obj)) {
    try {
      const {categoryName, date, matches} = obj?.data?.onUpdateResultsWidgetByDay;

      return {
              categoryName,
              date,
              matches: matches?.map((match) => {
                return {
                  ...match,
                  firstPosition: {
                    ...match?.firstPosition,
                    players: isNotEmptyArray(match?.firstPosition?.players) ? match?.firstPosition?.players : composeEmptyPlayers(categoryName!),
                  },
                  secondPosition: {
                    ...match?.secondPosition,
                    players: isNotEmptyArray(match?.secondPosition?.players) ? match?.secondPosition?.players : composeEmptyPlayers(categoryName!),
                  },
                }
              })
            } as ITennisResults;
    } catch (error) {
      logger.error(
        "ERROR 4003: transform() error in Results subscription transformer",
        obj
      );
      throw errors.fromCode(4003);
    }
  } else {
    logger.error("ERROR 4002", obj);
    throw errors.fromCode(4002);
  }
};
